<template>
  <ButtonSquare
    v-if="currentLevelOfDetail === 'SPACE'"
    size="small"
    class="navigation-buttons__button"
    :title="t('mapbox__navigation__control__lod_change')"
    :imgSource="iconSquare"
    @clicked="lod.cycleLevelOfDetail"
  />
  <ButtonSquare
    v-else-if="currentLevelOfDetail === 'LEVEL'"
    size="small"
    class="navigation-buttons__button"
    :title="t('mapbox__navigation__control__lod_change')"
    :imgSource="iconGrid"
    @clicked="lod.cycleLevelOfDetail"
  />
</template>

<script lang="ts" setup>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { useLevelOfDetail } from '@/pinia/levelOfDetail'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import iconSquare from '@/assets/square.svg'
import iconGrid from '@/assets/grid-01.svg'

const { t } = useI18n()
const lod = useLevelOfDetail()
const { currentLevelOfDetail } = storeToRefs(lod)
</script>
